import React from 'react';
import { products } from '../data/products';
import Hero from '../components/Hero';
import ProductCard from '../components/ProductCard';

const Shop = () => {
  return (
    <>
      <Hero
        title="Magazinul Interlink"
        subtitle="Echipamente și accesorii de calitate pentru conectivitate perfectă"
        backgroundImageUrl="/img/hero-shop.jpg"
      />

      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Shop;
